import { useContext } from 'react';

import '../init';
import { windowIsAvailable } from '../utils';
import { ModalManagerContext } from '../components/Modal/Contexts';

/**
 * @example const { create } = useModalManger();
 * @returns ...
 */
const useModalManager = () => {
  const context = windowIsAvailable
    ? window.cosmos.modalManagerContext ?? ModalManagerContext
    : ModalManagerContext;

  return useContext(context);
};

export default useModalManager;
